import { useStyles } from "components/FiltersV2/styles";
import { useMessage } from "hooks/intl";
import { SelectedFilter } from "types/filters";
import { Condition } from "./Condition";

interface Props {
  filter: SelectedFilter;
  index: number;
  size: "small" | "medium" | "inline";
  onChange?: (e?: any, value?: any) => void;
}

export const Conditions = ({ filter, index, size, onChange }: Props) => {
  const { message } = useMessage();
  const classes = useStyles();

  switch (filter.type) {
    case "boolean":
    case "boolean-status":
    case "boolean-yes-no":
    case "multiwithmodal":
    case "direct-campaign-name-filter":
    case "time-campaign-name-filter":
    case "referral-name-filter":
    case "direct-trigger-filter":
    case "referral-trigger-filter":
    case "country-filter":
    case "gender":
    case "tier-name-with-id-filter":
    case "bulk-actions":
    case "event-name-filter":
    case "reward-name-filter":
    case "reward-types-filter_eq":
    case "wallet-type-name-filter":
    case "tenant-name":
    case "import-type":
    case "export-type":
    case "export-status":
    case "campaign-name-filter":
    case "points-transfers-types":
    case "channel-filter":
    case "transaction-document-type":
    case "webhook-name-filter":
    case "tier-name-filter":
    case "redemption-code-status":
    case "import-details-status":
    case "segment-single":
      return <span className={classes.grayText}>{message({ id: "is" })}</span>;
    case "reward-categories":
    case "segments":
    case "tiers":
    case "multiinput":
      return <span className={classes.grayText}>{message({ id: "in" })}</span>;
    case "reward-types-filter":
      return (
        <span className={classes.grayText}>{message({ id: "isType" })}</span>
      );
    case "text":
      switch (filter.query) {
        case "address:address1":
        case "address:address2":
        case "address:city":
        case "referralToken":
        case "firstName":
        case "lastName":
        case "loyaltyCardNumber":
        case "address:postal":
        case "address:province":
        case "address:street":
        case "refereeName":
        case "referrerName":
        case "referrerToken":
        case "name":
        case "identifier":
        case "customerData:email":
        case "customerData:loyaltyCardNumber":
        case "customerData:phone":
        case "type":
        case "customerData:firstName":
        case "customerData:lastName":
        case "token":
        case "code":
        case "unitPluralName":
        case "entityId":
        case "entityType":
        case "eventType":
        case "ip":
        case "username":
        case "userType":
        case "comment":
        case "customerData:name":
        case "header:purchasePlace":
        case "url":
        case "description":
        case "currency":
        case "localeCode":
          return (
            <Condition
              items={["EQ", "LIKE"]}
              onChange={onChange}
              index={index}
              size={size}
            />
          );
        default:
          return (
            <span className={classes.grayText}>{message({ id: "is" })}</span>
          );
      }
    case "datetime":
    case "date":
      return (
        <Condition
          items={["BEFORE", "BEFORE_EQUAL", "AFTER", "AFTER_EQUAL"]}
          onChange={onChange}
          index={index}
          size={size}
        />
      );
    case "number":
      return (
        <Condition
          items={["LESS_THAN", "LESS_EQUAL", "GREATER_THAN", "GREATER_EQUAL"]}
          onChange={onChange}
          index={index}
          size={size}
        />
      );
    case "member-email-filter":
    case "member-phone-filter":
    case "wallet-type-code-filter":
    case "achievement-name":
    case "event-system-identifier-filter":
    case "member-loyalty-card-number":
    case "transaction-document-number":
      return (
        <Condition
          items={["EQ", "LIKE"]}
          onChange={onChange}
          index={index}
          size={size}
        />
      );
    case "timeline-event-type":
      return (
        <Condition
          items={["IN", "NOT_IN"]}
          onChange={onChange}
          index={index}
          size={size}
        />
      );
    case "reward-fulfillment-status":
      return (
        <Condition
          items={["EQ", "IN"]}
          onChange={onChange}
          index={index}
          size={size}
        />
      );
    default:
      return null;
  }
};
